import { Link } from 'react-router-dom';
import { FiArrowUpRight, FiCheck, FiClock } from 'react-icons/fi';
import { Template } from '../Template';
import { pricingPlans } from './types';
import './Pricing.css';

export const Pricing = () => <Template><section className="main-container">
  <span className="eyebrow">FIND YOUR FIT</span><h1>Your workflow. Your plan.</h1>
  <p className="page-description">Explore what Standard includes today and what we plan to bring to Slick next. <strong>Your first 7 days are a free trial.</strong></p>
  <p className="pricing-notice"><span className="status-dot" /> Slick is in development. Subscriptions are not available yet.</p>
  <div className="plans-container">{pricingPlans.map(plan => <article className={`plan${plan.name === 'Standard' ? ' plan-featured' : ''}`} key={plan.name}>
    <span className="eyebrow">{plan.name === 'Enterprise' ? 'FOR TEAMS' : 'EVERYDAY CREATING'}</span>
    <h2 className="plan-title">{plan.name}</h2><p className="plan-subtitle">{plan.description}</p>
    <div className="price-container"><span className="price">{plan.price ? `$${plan.price}` : 'Let’s talk'}</span>{plan.price && <span className="currency">USD / month</span>}</div>
    <ul className="plan-features">{plan.features.map(feature => <li key={feature}><FiCheck aria-hidden="true" />{feature}</li>)}</ul>
    {plan.name === 'Enterprise' ? <Link className="button button-primary" to="/contact">Contact us <FiArrowUpRight aria-hidden="true" /></Link> : <button className="button plan-unavailable" disabled>{plan.buttonName}</button>}
  </article>)}</div>
  <section className="pricing-roadmap" aria-labelledby="roadmap-title">
    <span className="eyebrow">WHAT'S NEXT</span>
    <h2 id="roadmap-title">Our plans for the near future.</h2>
    <p>These features are planned for upcoming updates and are not available yet.</p>
    <ul className="roadmap-features">
      {['Save and load scenes', 'Add supports to models', 'Automatically arrange models on the build plate', 'Send files to your printer remotely'].map(feature => <li key={feature}><FiClock aria-hidden="true" />{feature}</li>)}
    </ul>
  </section>
  <section className="pricing-community" aria-labelledby="community-title">
    <div>
      <span className="eyebrow">BUILT WITH OUR COMMUNITY</span>
      <h2 id="community-title">Small team. Shared ambition.</h2>
      <p>We're a small team building Slick, and we want to stay in close contact with the people who use it. We need our community's support to keep developing a great product. Your feedback, ideas, and everyday printing experiences help us decide what to build next.</p>
    </div>
    <Link className="button button-secondary" to="/contact">Share your feedback <FiArrowUpRight aria-hidden="true" /></Link>
  </section>
  <p className="pricing-help">Need something specific? <Link to="/contact">Tell us about your workflow ↗</Link></p>
</section></Template>;
